import React from "react";
import styles from "../login/index.module.scss";
import OtpVerificationC from "../../../stories/investor/opt-verification";

export default function OtpVerification() {
  return (
    <div className={styles.loginBg}>
      <OtpVerificationC />
    </div>
  );
}
